import BodaAtelier from "./BodaAtelier";
import { datosEjemplo } from "./sampleData";
import { paletas } from "./paletas";

export const definicion = {
  id: "boda-atelier",
  tipoEvento: "boda",
  tipoEtiqueta: "Boda",
  nombre: "Atelier",
  descripcion:
    "Clásico centrado de aire atelier: monograma, ornamento tipográfico, marco ovalado y textos verticales laterales en escritorio. Su portada admite video ambiental de YouTube con poster de respaldo.",
  miniatura: datosEjemplo.fotos.portada,
  miniaturas: {
    perla: "/miniaturas/boda-atelier-perla.jpg",
    oliva: "/miniaturas/boda-atelier-oliva.jpg",
    ciruela: "/miniaturas/boda-atelier-ciruela.jpg",
  },
  paletas,
  datosEjemplo,
  Componente: BodaAtelier,
};
